// extracted by mini-css-extract-plugin
export var addToCartButton = "_m3-b";
export var arrowButtonContainer = "_m3-9";
export var arrowButtonIcon = "_m3-a";
export var carouselArrowButton = "_m3-6";
export var carouselElementContainer = "_m3-1";
export var left = "_m3-7";
export var productDisplayCarouselContainer = "_m3-0";
export var productTileContainer = "_m3-2";
export var productTileImage = "_m3-4";
export var productTileImageContainer = "_m3-3";
export var productTileTitle = "_m3-5";
export var right = "_m3-8";
export var sliderOverflow = "_m3-c";